var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgHeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 56,
    viewBox: "0 0 1440 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_1148)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 893.783,
    height: 893.783,
    rx: 20,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 983 -698)",
    fill: "url(#paint0_linear_398_1148)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 582.81,
    height: 582.81,
    rx: 20,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 1302.11 -286)",
    fill: "url(#paint1_linear_398_1148)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 55H0V57H1440V55Z",
    fill: "white",
    fillOpacity: 0.25,
    mask: "url(#path-1-inside-1_398_1148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_398_1148",
    x1: 885.65,
    y1: 282.486,
    x2: 274.59,
    y2: 366.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661465,
    stopColor: "#2537A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_1148",
    x1: 425.755,
    y1: 19.0148,
    x2: 405.249,
    y2: 342.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CEAB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661465,
    stopColor: "#2537A8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_1148"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V56H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeader);
export default __webpack_public_path__ + "static/media/bg-header.568a84ab34b192ed2b4b1b2e69b60a4f.svg";
export { ForwardRef as ReactComponent };